import { TermsAndConditionsType } from 'pages/TermsAndConditionsPage/ts';


export const TERMS_AND_CONDITIONS: TermsAndConditionsType = {
  title: 'title',
  subTitle: 'subTitle',
  termsList: [
    {
      id: 'section1',
      title: 'section1.title',
      sectionList: [
        {
          id: 'item1',
          subList: [
            'section1.list.p1',
            'section1.list.p2',
            'section1.list.p3',
            'section1.list.p4',
            'section1.list.p5',
          ],
        },
      ],
    },
    {
      id: 'section2',
      title: 'section2.title',
      sectionList: [
        {
          id: 'item0',
          subList: [
            'section2.list.item0.p1',
          ]
        },
        {
          id: 'item1',
          title: "section2.list.item1.title",
          subList: [
            'section2.list.item1.p1',
          ]
        },
        {
          id: 'item2',
          title: "section2.list.item2.title",
          subList: [
            'section2.list.item2.p1',
          ]
        },
        {
          id: 'item3',
          title: "section2.list.item3.title",
          subList: [
            'section2.list.item3.p1',
          ]
        },
        {
          id: 'item4',
          title: "section2.list.item4.title",
          subList: [
            'section2.list.item4.p1',
          ]
        },
        {
          id: 'item5',
          title: "section2.list.item5.title",
          subList: [
            'section2.list.item5.p1',
          ]
        }
      ]
    },
    {
      id: 'section3',
      title: 'section3.title',
      sectionList: [
        {
          id: 'item1',
          title: "section3.list.item1.title",
          subList: [
            'section3.list.item1.p1',
          ]
        },
        {
          id: 'item2',
          title: "section3.list.item2.title",
          subList: [
            'section3.list.item2.p1',
            'section3.list.item2.p2',
          ]
        },
        {
          id: 'item3',
          title: "section3.list.item3.title",
          subList: [
            'section3.list.item3.p1',
          ]
        },
        {
          id: 'item4',
          title: "section3.list.item4.title",
          subList: [
            'section3.list.item4.p1',
          ]
        },
        {
          id: 'item5',
          title: "section3.list.item5.title",
          subList: [
            'section3.list.item5.p1',
          ]
        },
        {
          id: 'item6',
          title: "section3.list.item6.title",
          subList: [
            'section3.list.item6.p1',
          ]
        },
        {
          id: 'item7',
          title: "section3.list.item7.title",
          subList: [
            'section3.list.item7.p1',
            'section3.list.item7.p2',
          ]
        }
      ]
    },
    {
      id: 'section4',
      title: 'section4.title',
      sectionList: [
        {
          id: 'item1',
          title: "section4.list.item1.title",
          subList: [
            'section4.list.item1.p1',
          ]
        },
        {
          id: 'item2',
          title: "section4.list.item2.title",
          subList: [
            'section4.list.item2.p1',
          ]
        },
        {
          id: 'item3',
          title: "section4.list.item3.title",
          subList: [
            'section4.list.item3.p1',
          ]
        }
      ]
    },
    {
      id: 'section5',
      title: 'section5.title',
      sectionList: [
        {
          id: 'item0',
          subList: [
            'section5.list.item0.p1',
          ]
        },
        {
          id: 'item1',
          title: "section5.list.item1.title",
          subList: [
            'section5.list.item1.p1',
          ]
        },
        {
          id: 'item2',
          title: "section5.list.item2.title",
          subList: [
            'section5.list.item2.p1',
          ]
        },
        {
          id: 'item3',
          title: "section5.list.item3.title",
          subList: [
            'section5.list.item3.p1',
          ]
        }
      ]
    },
    {
      id: 'section6',
      title: 'section6.title',
      sectionList: [
        {
          id: 'item1',
          title: "section6.list.item1.title",
          subList: [
            'section6.list.item1.p1',
            'section6.list.item1.p2',
            'section6.list.item1.p3',
          ]
        },
        {
          id: 'item2',
          title: "section6.list.item2.title",
          subList: [
            'section6.list.item2.p1',
            'section6.list.item2.p2',
            'section6.list.item2.p3',
          ]
        },
        {
          id: 'item3',
          title: "section6.list.item3.title",
          subList: [
            'section6.list.item3.p1',
          ]
        }
      ]
    },
    {
      id: 'section7',
      title: 'section7.title',
      sectionList: [
        {
          id: 'item1',
          title: "section7.list.item1.title",
          subList: [
            'section7.list.item1.p1',
          ]
        },
        {
          id: 'item2',
          title: "section7.list.item2.title",
          subList: [
            'section7.list.item2.p1',
          ]
        }
      ]
    },
    {
      id: 'section8',
      title: 'section8.title',
      sectionList: [
        {
          id: 'item1',
          title: "section8.list.item1.title",
          subList: [
            'section8.list.item1.p1',
          ]
        },
        {
          id: 'item2',
          title: "section8.list.item2.title",
          subList: [
            'section8.list.item2.p1',
            'section8.list.item2.p2',
            'section8.list.item2.p3',
            'section8.list.item2.p4',
            'section8.list.item2.p5',
          ]
        },
        {
          id: 'item3',
          title: "section8.list.item3.title",
          subList: [
            'section8.list.item3.p1',
            'section8.list.item3.p2',
          ]
        }
      ]
    },
    {
      id: 'section9',
      title: 'section9.title',
      sectionList: [
        {
          id: 'item1',
          title: "section9.list.item1.title",
          subList: [
            'section9.list.item1.p1',
          ]
        },
        {
          id: 'item2',
          title: "section9.list.item2.title",
          subList: [
            'section9.list.item2.p1',
          ]
        },
        {
          id: 'item3',
          title: "section9.list.item3.title",
          subList: [
            'section9.list.item3.p1',
          ]
        }
      ]
    },
    {
      id: 'section10',
      title: 'section10.title',
      sectionList: [
        {
          id: 'item1',
          title: "section10.list.item1.title",
          subList: [
            'section10.list.item1.p1',
          ]
        }
      ]
    },
    {
      id: 'section11',
      title: 'section11.title',
      sectionList: [
        {
          id: 'item1',
          title: "section11.list.item1.title",
          subList: [
            'section11.list.item1.p1',
          ]
        },
        {
          id: 'item2',
          title: "section11.list.item2.title",
          subList: [
            'section11.list.item2.p1',
          ]
        },
        {
          id: 'item3',
          title: "section11.list.item3.title",
          subList: [
            'section11.list.item3.p1',
          ]
        },
        {
          id: 'item4',
          title: "section11.list.item4.title",
          subList: [
            'section11.list.item4.p1',
          ]
        },
        {
          id: 'item5',
          title: "section11.list.item5.title",
          subList: [
            'section11.list.item5.p1',
          ]
        },
        {
          id: 'item6',
          title: "section11.list.item6.title",
          subList: [
            'section11.list.item6.p1',
          ]
        },
        {
          id: 'item7',
          title: "section11.list.item7.title",
          subList: [
            'section11.list.item7.p1',
          ]
        },
        {
          id: 'item8',
          title: "section11.list.item8.title",
          subList: [
            'section11.list.item8.p1',
          ]
        },
        {
          id: 'item9',
          title: "section11.list.item9.title",
          subList: [
            'section11.list.item9.p1',
          ]
        },
        {
          id: 'item10',
          title: "section11.list.item10.title",
          subList: [
            'section11.list.item10.p1',
          ]
        },
        {
          id: 'item11',
          title: "section11.list.item11.title",
          subList: [
            'section11.list.item11.p1',
            'section11.list.item11.p2',
          ]
        },
        {
          id: 'item12',
          title: "section11.list.item12.title",
          subList: [
            'section11.list.item12.p1',
            'section11.list.item12.p2',
            'section11.list.item12.p3',
            'section11.list.item12.p4',
            'section11.list.item12.p5',
            'section11.list.item12.p6',
            'section11.list.item12.p7',
            'section11.list.item12.p8',
          ]
        }
      ]
    }
  ],
};